import { EpicType } from "../models/EpicType";
import { host, getRequest, patchRequest, postRequest, deleteRequest } from "./apiService";

export async function getEpicTypes() {
	return getRequest<EpicType[]>(`${host}/api/epicType`);
}
export async function updateEpicType(epicType: EpicType) {
	return patchRequest<void>(
		`${host}/api/epicType/${epicType.id}`, epicType
	);
}
export async function addEpicType(newepicType: EpicType) {
	const { id, ...objectWithoutId } = newepicType;
	return postRequest<EpicType | undefined>(
		`${host}/api/epicType`, objectWithoutId
	);
}
export async function deleteEpicType(id: number) {
	return deleteRequest(`${host}/api/epicType/${id}`);
}